import { ToastConfig, ToastRef } from './toast.models';

/**
 * Portal-wide toast overlay (Gmail-style). Distinct from balloon {@link NotificationService}.
 */
export abstract class ToastService {
  abstract show(config: ToastConfig): ToastRef;

  abstract closeAll(): void;

  abstract hasUndoEligible(): boolean;

  abstract undoTop(): boolean;
}
